import { useEffect, useState } from 'react';
import { Box, Button, Modal } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { sxButton, sxCheckbox, sxOutlinedButton, sxTermsOfUseModal } from './sxProps';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import './styles.css'
import parse from 'html-react-parser';
import { useAccessibility } from '../../Store/contexts/AccessibilityContext';
import { ModalTermsProps } from '../../interfaces/props/ModalTermsProps';

function ModalTerms(props: ModalTermsProps) {

    const [agreed, setAgreed] = useState<boolean>(false);

    const { fontSizeStyleAccessibility, fontSize } = useAccessibility();


    const handleCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
        setAgreed(event.target.checked);
    };

    const handleProceed = () => {
        props.handleTermsOfUse(agreed);
    }

    const handleCloseModal = () => {
        setAgreed(false)
        props.closeTermsOfUse();
    }

    return (
        <div>
            <Modal
                open={props.open}
                onClose={handleCloseModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={sxTermsOfUseModal}>
                    <div className="terms-of-use-holder">
                        <div className="terms-of-use-modal-header">
                            <h1 className="terms-title" style={fontSizeStyleAccessibility} tabIndex={0}>Termo de uso</h1> <button className='terms-of-use-modal-header-close' onClick={handleCloseModal}><FontAwesomeIcon icon={faTimes} /></button>
                        </div>
                        <div className="terms-description-holder">
                            <div className="terms-description" style={fontSizeStyleAccessibility} tabIndex={0}>
                                {parse(props.terms.descricao)}
                            </div>
                        </div>
                        <div className="terms-checkbox" style={fontSizeStyleAccessibility}>
                            <FormControlLabel control={<Checkbox onChange={handleCheck}/>} label="Eu li e concordo com os termos" sx={sxCheckbox}/>
                        </div>
                        <div className="terms-of-use-buttons-holder">
                            <div className="terms-of-use-buttons">
                                <Button 
                                variant="outlined" 
                                size="large"
                                onClick={handleCloseModal}
                                sx={sxOutlinedButton}
                                style={fontSizeStyleAccessibility}
                                fullWidth>
                                    <span style={{color: '#00995D'}}>
                                        CANCELAR
                                    </span>
                                </Button>
                            </div>
                            <div className="terms-of-use-buttons">
                                <Button 
                                variant="contained" 
                                size="large"
                                onClick={handleProceed}
                                sx={sxButton}
                                style={fontSizeStyleAccessibility}
                                fullWidth
                                disabled={!agreed}>
                                CONFIRMAR
                                </Button>
                            </div>
                        </div>
                    </div>
                </Box>
            </Modal>
        </div>
    )
}

export default ModalTerms;